import React from 'react';
import FadeIn from '../common/FadeIn';

const BlogHeroSection = () => {
  return (
    <FadeIn className="text-center mb-8 md:mb-12">
      <h1 className="font-saolDisplayItalic text-[36px] sm:text-[48px] md:text-[64px] font-normal uppercase tracking-[0.06em] text-[#1C1917]">
        THE BLOG
      </h1>
    </FadeIn>
  );
};

export default BlogHeroSection;
